import * as colors from "@remar/shared/dist/colors";

import { DoubleExtendedPalette } from "@remar/shared/dist/models/theme.types";

import defaultColorPalette from "./light_defaultPalette";

const colorPalette: Partial<DoubleExtendedPalette> = {
	type: "light",
	...defaultColorPalette,
	primary: {
		text: colors.basic[800],
		contrastText: colors.basic[100],
		dark: colors.orange[800],
		light: colors.orange[200],
		main: colors.orange[400],
		tabs: {
			border: colors.orange[500],
			contrastText: colors.orange[800],
			main: colors.orange[300]
		}
	},
	secondary: {
		text: colors.basic[600],
		contrastText: colors.orange[400],
		dark: colors.orange[800],
		light: colors.orange[200],
		main: colors.orange[200],
		tabs: {
			contrastText: colors.orange[800],
			dark: colors.orange[500],
			main: colors.orange[200],
			border: colors.orange[400]
		}
	}
};

export default colorPalette;
